import React, { Component } from 'react'
import { connect } from 'react-redux';
import SpeedControl from '../components/SpeedControl'
import StatsButton from '../components/PopupStats/StatsButton'
import { toggle_settings_window_visibility, toggle_about_window_visibility} from '../actions/statisticActions'

class Header extends Component {
	
	getCurrentMinuteText() {
      if(this.props.CurrentEvent == 0)
        return "00";

	  let minute =  parseInt(window.Json.game[this.props.CurrentEvent-1].minute);
	  if(minute < 100)
		return ("0" + minute).slice(-2);
	  else
		return minute + "";
    }
	
	render() {
		var weather = this.props.Weather;
		let minute = this.getCurrentMinuteText();

		return (<div className="row" id="header">
					<div className="col-md-3 col-xs-3 col-sm-3 control-buttons">
						<SpeedControl min={38} max={8} step={5} />
					</div>
					<div className="col-md-6 col-xs-6 col-sm-5 center-section">
						<div className="teamname">{this.props.Home.Name}</div>
						<div className="flags-score"><img src={this.props.Home.Flag} />{this.props.Home.Score}:{this.props.Away.Score}<img src={this.props.Away.Flag} /></div>
						<div className="teamname">{this.props.Away.Name}</div>
					</div>
					<div className="col-md-3 col-xs-3 col-sm-4 right-section">
							<div className="col-md-6 col-sm-4 vcenter">
								<div className="game-time"><i className="fa fa-clock-o" aria-hidden="true"></i>{minute} {this.props.TimeAdded != null ? "(+" + this.props.TimeAdded  + ")" : ""}</div>
							</div>
							<div className="col-md-2 col-sm-2 vcenter">
								<i className="fa fa-question" role="button" aria-hidden="true" onClick={() => this.props.dispatch(toggle_about_window_visibility())}></i>
							</div>
							<div className="col-md-2 col-sm-2 vcenter">
								<i className="fa fa-sliders" role="button" aria-hidden="true" id='settings_button' onClick={() => this.props.dispatch(toggle_settings_window_visibility())}></i>
							</div>
							<div className="col-md-2 col-sm-2 vcenter">
								<StatsButton />
							</div>
					</div>
				</div>)
    }
}
function mapStateToProps(state, ownProps) {
    return {
        Home: {
			Score: state.Stats.Score.Home,
			Name: state.HomeTeam.Name,
			Flag: 'https://pefl.ru/'+state.HomeTeam.Flag
		},
		Away: {
			Score: state.Stats.Score.Away,
			Name: state.AwayTeam.Name,
			Flag: 'https://pefl.ru/'+state.AwayTeam.Flag
		},
		Weather: state.weather,
		CurrentEvent: state.currentEvent,
		TimeAdded: state.timeAdded
    };
}

export default connect(mapStateToProps)(Header)



/** WEBPACK FOOTER **
 ** ./src/components/HeaderComponent.js
 **/